<template>
	<div class="indicator_base bg-white text-center">
		<div class="base_data">
			<template v-for="(item, index) in list">
				<span v-if="index" class="line" :key="`base_data_span_${index}`"></span>
				<div class="base_data_item" :key="`base_data_dev_${index}`">
					<h2 class="value">
						<template v-if="item.value">
							{{ item.value | itemValueFilter }}
							<span class="custom_company">{{ item.unit }}</span>
						</template>
						<span v-else>--</span>
					</h2>
					<p class="unit">{{ item.label }}</p>
					<p v-if="item.tag">
						<span class="custom_tag" :class="item.tag">
							{{ $status.bloodStatusStr[item.tag] }}
						</span>
					</p>
				</div>
			</template>
		</div>
		<div class="record_date" v-if="!loading">
			<p v-if="recordDate">{{ recordDate }}</p>
			<p v-else-if="recordDesc">{{ recordDesc }}</p>
		</div>
		<div v-else class="record_date">数据采集中...</div>
		<div class="record_status" v-if="status && !loading">
			<span :class="status">{{ $status.bloodStatusStr[status] }}</span>
		</div>
	</div>
</template>

<script>
export default {
    name: 'indicatorBase',
    props: {
        list: {
            type: Array,
            default: () => ([])
        },
        recordDate: {
            type: String,
            default: ''
        },
        recordDesc: {
            type: String,
            default: ''
        },
        status: {
            type: [String, Number],
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        itemValueFilter (val) {
            if (typeof val === 'number' && !Number.isNaN(val)) return val + ''
            if (val && typeof val === 'string') return val
            return '--'
        }
    }
}
</script>

<style scoped lang="less">
.indicator_base {
	border-radius: 16px;
	.base_data {
		padding: 40px 0;
		display: flex;
		justify-content: center;
		align-items: center;
		.line {
			width: 1px;
			height: 64px;
			background-color: #eee;
		}
		.base_data_item {
			flex: 1;
			position: relative;
			.value {
				font-family: PingFangSC-Medium;
				font-size: 40px;
				font-weight: normal;
				line-height: 40px;
				color: #1f2329;
				vertical-align: bottom;
				.custom_company {
					font-size: 24px;
				}
			}
			.custom_tag {
				margin-top: 25px;
				text-align: center;
				font-size: 24px;
				display: inline-block;
			}
			.unit {
				margin-top: 12px;
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				line-height: 29px;
				color: #8f959e;
			}
		}
	}
	.record_date {
		font-family: PingFangSC-Regular;
		font-size: 26px;
		font-weight: normal;
		letter-spacing: 0.43px;
		color: @gray-9;
		padding-bottom: 32px;
	}
	.record_status {
		font-family: PingFangSC-Semibold;
		font-size: 38px;
		font-weight: normal;
		letter-spacing: 0.5px;
		padding-bottom: 32px;
		.high {
			color: @danger;
		}
		.normal {
			color: @primary;
		}
		.low {
			color: @info;
		}
	}
}
</style>
